import { useState, useEffect } from "react";
import styles from "./AddNewActionModal.module.scss";
import Button from "../../../../../../common/components/xepp/button/Button";
import { CloseIcon } from "../../../../../../assets/icons";

interface AddNewActionModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSave: (actionName: string) => void;
	editingActionName?: string;
}

const AddNewActionModal = ({ isOpen, onClose, onSave, editingActionName }: AddNewActionModalProps) => {
	const [actionName, setActionName] = useState("");

	const isEditMode = !!editingActionName;

	useEffect(() => {
		if (editingActionName && isOpen) {
			setActionName(editingActionName);
		} else if (!editingActionName && isOpen) {
			setActionName("");
		}
	}, [editingActionName, isOpen]);

	const handleSave = () => {
		if (actionName.trim()) {
			onSave(actionName.trim());
			setActionName("");
			onClose();
		}
	};

	const handleCancel = () => {
		setActionName("");
		onClose();
	};

	if (!isOpen) return null;

	return (
		<div className={styles.modalOverlay} onClick={handleCancel}>
			<div className={styles.modalContent} onClick={e => e.stopPropagation()}>
				<button className={styles.closeButton} onClick={handleCancel}>
					<CloseIcon />
				</button>

				<div className={styles.modalHeader}>
					<h2 className={styles.modalTitle}>{isEditMode ? "Edit Action" : "Add New Action"}</h2>
					<p className={styles.modalSubtitle}>Give this section a name</p>
				</div>

				<div className={styles.modalBody}>
					<input
						type="text"
						className={styles.input}
						placeholder="Enter Name"
						value={actionName}
						onChange={e => setActionName(e.target.value)}
						onKeyDown={e => {
							if (e.key === "Enter") {
								handleSave();
							}
						}}
						autoFocus
					/>
				</div>

				<div className={styles.modalFooter}>
					<Button text="Cancel" onClick={handleCancel} variant="outline" />
					<Button text="Save" onClick={handleSave} variant="secondary" />
				</div>
			</div>
		</div>
	);
};

export default AddNewActionModal;

